import { useNavigate } from "react-router-dom";
import {
  UserPlus,
  FileText,
  Package,
  CreditCard,
  Contact,
  Car,
  Shield,
  CalendarPlus,
} from "lucide-react";
import { Button } from "@/components/ui/button";

const actions = [
  {
    title: "Nuevo Usuario",
    icon: UserPlus,
    variant: "default" as const,
    href: "/users",
  },
  {
    title: "Alta Cliente",
    icon: Contact,
    variant: "secondary" as const,
    href: "/crm/clients",
  },
  {
    title: "Nueva Matrícula",
    icon: Car,
    variant: "secondary" as const,
    href: "/registrations/list",
  },
  {
    title: "Nuevo Seguro",
    icon: Shield,
    variant: "secondary" as const,
    href: "/insurance/clients",
  },
  {
    title: "Nueva Cita",
    icon: CalendarPlus,
    variant: "secondary" as const,
    href: "/crm/appointments",
  },
  {
    title: "Crear Factura",
    icon: FileText,
    variant: "secondary" as const,
    href: "/finance/invoices",
  },
  {
    title: "Agregar Producto",
    icon: Package,
    variant: "secondary" as const,
    href: "/erp/products",
  },
  {
    title: "Registrar Pago",
    icon: CreditCard,
    variant: "secondary" as const,
    href: "/finance/payments",
  },
];

export function QuickActions() {
  const navigate = useNavigate();

  return (
    <div className="chart-container animate-slide-in-up" style={{ animationDelay: "350ms" }}>
      <div className="mb-6">
        <h3 className="font-display text-lg font-semibold text-foreground">
          Acciones Rápidas
        </h3>
        <p className="text-sm text-muted-foreground">
          Operaciones frecuentes
        </p>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {actions.map((action, index) => (
          <Button
            key={action.title}
            variant={action.variant}
            className="h-auto flex-col gap-2 py-4 animate-scale-in"
            style={{ animationDelay: `${450 + index * 50}ms` }}
            onClick={() => navigate(action.href)}
          >
            <action.icon className="h-5 w-5" />
            <span className="text-xs">{action.title}</span>
          </Button>
        ))}
      </div>
    </div>
  );
}
